<script setup lang="ts">
defineProps({ blok: Object })

const localePath = useLocalePath()
</script>

<template>
    <section class="relative py-32 bg-[#947DBA] overflow-hidden max-[641px]:py-20">
        <div class="px-9 grid grid-cols-12">
            <div class="col-span-6 max-[769px]:col-span-8 max-[641px]:col-span-12">
                <div class="mb-4 [&>p]:font-medium [&>p]:fs-4xl [&>p]:font-eb-garamond [&>p]:text-chsc-yellow  [&>p>strong]:font-medium [&>p>strong]:text-chsc-indigo-500">
                    <StoryblokRichText
                        :doc="blok?.edition"
                    />
                </div>
                <img
                    v-motion-slide-top
                    class="mb-4 w-full max-w-full"
                    :src="blok?.header.filename"
                >
                <p class="font-eb-garamond fs-3xl text-chsc-indigo-500 font-semibold">
                    {{ blok?.claim }}
                </p>
                <div class="mt-8">
                    <UButton
                        :to="localePath('/scorecards')"
                        :label="blok?.cta"
                        size="xl"
                    />
                </div>
            </div>
        </div>
        <div class="absolute top-0 right-0 w-5/12  h-full max-[769px]:w-3/12 max-[641px]:hidden">
            <img
                v-motion-slide-left
                class="w-full h-full object-cover object-left"
                :src="blok?.image.filename"
            >
        </div>
    </section>
</template>
